// extracted by mini-css-extract-plugin
export var banner = "_qa-0";
export var settingRow = "_qa-2";
export var titleIcon = "_qa-1";